import { useSendFormMutation } from "../../redux/services/crmAPI";
import { useEffect, useState } from "react";
import { succsesDataAddAlert } from "../../alerts/alerts";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Client = () => {
    const navigate = useNavigate();

    const permissions = useSelector((state) => state.status.permissions);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [address, setAddress] = useState("");
    const [card, setCard] = useState("");
    const [discount, setDiscount] = useState(0);

    const [sendForm, { isLoading, isError, isSuccess }] = useSendFormMutation();

    const sendFormHandler = async () => {
        const formData = {
            name: name,
            email: email,
            phone: phone,
            address: address,
            card: card,
            discount: discount,
        };

        await sendForm({ body: formData, url: "clients", method: "POST" }).unwrap();

        // if (!isError) {
        //     succsesDataAddAlert();
        //     navigate("/clients");
        // }
    };

    useEffect(() => {
        if (isSuccess) {
            succsesDataAddAlert();
            navigate("/clients");
        }
    }, [isSuccess]);

    return (
        <>
            {
                <div className="content">
                    <div className="col-12">
                        <div id="page-header">
                            <h1>Додати клієнта</h1>
                        </div>
                        <div className="form client_form">
                            <input type="hidden" name="id" />
                            <div className="row">
                                <div className="col-12 col-sm-6 col-lg-6">
                                    <div className="card card-default">
                                        <div className="card-header">Інформація покупця</div>
                                        <div className="card-body">
                                            <div className="mb-2">
                                                <label className="form-label">Ім'я</label>
                                                <input
                                                    className="form-control"
                                                    maxLength="255"
                                                    type="text"
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-2">
                                                <label className="form-label">Телефон</label>
                                                <input
                                                    className="form-control"
                                                    maxLength="255"
                                                    type="text"
                                                    value={phone}
                                                    onChange={(e) => setPhone(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-2">
                                                <label className="form-label">Email</label>
                                                <input
                                                    className="form-control"
                                                    maxLength="255"
                                                    type="text"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-2">
                                                <label className="form-label">Адреса</label>
                                                <input
                                                    className="form-control"
                                                    maxLength="255"
                                                    type="text"
                                                    value={address}
                                                    onChange={(e) => setAddress(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {permissions.includes("client_edit") || permissions.includes("all") ? (
                                        <div className="saves_block">
                                            <button
                                                name="user_info"
                                                className="btn btn-primary"
                                                onClick={sendFormHandler}
                                            >
                                                {isLoading ? "Завантаження" : "Зберегти"}
                                            </button>
                                        </div>
                                    ) : null}
                                </div>

                                <div className="col-12 col-sm-6 col-lg-6">
                                    <div className="card card-default">
                                        <div className="card-header">Дисконтна карта клієнта</div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-12 col-sm-6">
                                                    <div className="mb-2">
                                                        <label className="form-label">Номер карти</label>
                                                        <input
                                                            type="text"
                                                            name="card"
                                                            className="form-control"
                                                            value={card}
                                                            onChange={(e) => setCard(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="mb-2">
                                                        <label className="form-label">Знижка</label>
                                                        <div className="input-group">
                                                            <input
                                                                type="text"
                                                                name="discount"
                                                                className="form-control"
                                                                value={discount}
                                                                onChange={(e) => setDiscount(e.target.value)}
                                                            />
                                                            <span className="input-group-text" id="discount">
                                                                %
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-sm-6">
                                                    <svg id="barcode_card"></svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default Client;
